<template>
  <div class="share-frame">
    <div class="frame">
      <slot></slot>
    </div>
    <div class="tail">
      <div class="logo"><img src="@/assets/logo-vertical.svg"></div>
      <div class="site-url">riseup.co.il</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ShareFrame',
};
</script>

<style lang="scss">
@import '~base-ui/src/scss/riseup-colors';

.share-frame {
  display: flex;
  flex-direction: column;
  padding: 50px 50px 25px;
  background-color: $riseup_yellow;

  .frame {
    background-color: $riseup_white;
    margin-bottom: 25px;
    border-radius: 8px;
  }

  .tail {
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-end;
    justify-content: space-between;
    .logo img {
      height: 45px;
    }
    .site-url {
      font-family: SimplerPro;
      color: $riseup_black;
      font-size: 18px;
    }
  }
}

</style>
